export default "__VITE_ASSET__s9r9MTgv__"